import { render, staticRenderFns } from "./UltimasOS.vue?vue&type=template&id=69a956a6&"
import script from "./UltimasOS.vue?vue&type=script&lang=js&"
export * from "./UltimasOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports